import { AxiosResponse } from 'axios'
import { valueof } from 'src/@types/global'
import { Axios } from 'src/service/axios/axios'
import { ENTITY_TYPE, FILE_TYPE } from 'src/shared/constants/constants'
import { EnvironmentStore } from 'src/env/EnvironmentStore'
import { downloadBlobFile, downloadBlobFileWithFileName } from 'src/shared/utils/BlobUtils'

export const FileService = {
  upload: async (
    file: Blob,
    fileType: valueof<typeof FILE_TYPE>,
    entityType: valueof<typeof ENTITY_TYPE>,
    entityId: string | number,
    fileTitle: string,
  ): Promise<AxiosResponse> => {
    const formData = new FormData()
    formData.append('uploadFile', file)
    formData.append('fileType', fileType)
    formData.append('entityType', entityType)
    formData.append('entityId', `${entityId}`)
    formData.append('fileTitle', fileTitle)

    const response = await Axios.getAxios().post('/api/file', formData)
    return response.data
  },

  remove: (fileUUID: string): Promise<AxiosResponse> => {
    return Axios.getAxios()
      .delete(`/api/file/${fileUUID}`)
      .then((response) => response.data)
  },

  download: (fileUUID: string): Promise<void> => {
    return downloadBlobFile(FileService.getUrlForFileDownload(fileUUID))
  },

  downloadWithFileName: (fileUUID: string, fileName: string): Promise<void> => {
    return downloadBlobFileWithFileName(FileService.getUrlForFileDownload(fileUUID), fileName)
  },

  getUrlForFileDownload: (fileUUID: string): string => {
    const backendUrl = EnvironmentStore.backendUrl
    return `${backendUrl}/api/file/${fileUUID}`
  },
}
